module.exports = __webpack_public_path__ + "img/image_2-0b4bd5b4.png";